

























import { Component, Vue } from 'vue-property-decorator';

import Modal from "./Base.vue";
import TextField from '../Form/TextField.vue';
import SelectField from '../Form/SelectField.vue';
import BrandService from '@/services/Brand';

@Component( {
	name: "AddPolicyModal",
	components: {
        Modal,
        TextField,
        SelectField
	}
} )
export default class AddPolicyModal extends Vue {
    private policyNumber: string = '';
    private selectedBrand: string = '';
    private BrandService: typeof BrandService = BrandService;
}
